import { CallToAction } from 'components/CallToAction'
import { GatsbyImage } from 'gatsby-plugin-image'
import Slider from 'react-slick'
import { heading, section,programgoalssection } from '../classes'
import {prepareData} from 'utils/googleData'
import React from 'react';
import {ProgramGoals,StandardPlan,EnterprisePlan} from 'components/NotProductIcons'
import Link from 'components/Link'

const goals = [
	'(January / February / March)',
	'(April / May / June)',
	'(July / August / September)',
	'(October / November / December)',
]

export * from './SuperPowers'
export * from './Levels'

export default function HowTo(props) {
    const {enable,title,subtitle,description,homeMarketsTitle,cta,markets,direction,text,style,gatsbyImage,sections,gatsbyImage2}= prepareData({props})
        if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }
    return (
        <section dir={direction} className={section()}>
<div className="py-[60px] rounded-t-[24px]" style={{ background: 'linear-gradient(#24b7ff, #24b7ff)' }}>
<div
   className="p-[10px] max-w-[1100px] mx-auto sm:p-[24px]"
>
<figure className="mx-2 text-center">
                  <ProgramGoals />
{/* <figcaption>Basic plan</figcaption> */}
</figure>
    <h3>How to set program goals</h3>
    <p>Determine your OKR calendar</p>
    <p>
        Most companies plan their OKRs quarterly, as
        follows:
    </p>

    <div  className="mt-[36px] grid grid-cols-1 gap-[24px] md:grid-cols-2">
        {goals.map((goal, index) => (
            <div className="bg-white p-[18px] rounded-[16px]" key={index}>
                <div className="text-[#00536b] m-[22px] text-[22px]">
                    Q{index + 1}
                </div>
                <div className="max-w-[640px] text-[20px] text-[#18171c] opacity-80">
                    {goal}
                </div>
            </div>
        ))}
    </div>
</div>
</div>
</section>
    )
}


